import { Component } from '@theme/component';

const MOBILE = '(max-width: 989px)';

class SimucubeResellerGrid extends Component {
  requiredRefs = ['grid'];

  #mobile = window.matchMedia(MOBILE);

  connectedCallback() {
    super.connectedCallback();
    this.refs.viewMoreButton?.addEventListener('click', this.#reveal);
    if (this.refs.viewMoreButton) {
      this.#mobile.addEventListener('change', this.#sync);
      this.#sync();
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.refs.viewMoreButton?.removeEventListener('click', this.#reveal);
    this.#mobile.removeEventListener('change', this.#sync);
  }

  get #batchSize() {
    return parseInt(this.dataset.initialCount, 10) || 4;
  }

  get #hiddenCells() {
    return this.refs.grid.querySelectorAll('.sc-reseller-grid__cell--extra:not(.is-revealed)');
  }

  #sync = () => {
    const collapsible = this.#mobile.matches && this.#hiddenCells.length > 0;
    this.toggleAttribute('data-collapsed', collapsible);
    this.refs.viewMoreButton.hidden = !collapsible;
  };

  #reveal = () => {
    const batch = Array.from(this.#hiddenCells).slice(0, this.#batchSize);

    for (const cell of batch) {
      cell.classList.add('is-revealed');
    }

    const [first] = batch;
    if (first) {
      first.setAttribute('tabindex', '-1');
      first.focus({ preventScroll: false });
    }

    const done = this.#hiddenCells.length === 0;
    this.refs.viewMoreButton.setAttribute('aria-expanded', done ? 'true' : 'false');
    if (done) {
      this.refs.viewMoreButton.hidden = true;
      this.removeAttribute('data-collapsed');
    }
  };
}

if (!customElements.get('simucube-reseller-grid')) {
  customElements.define('simucube-reseller-grid', SimucubeResellerGrid);
}
